module.exports = __webpack_public_path__ + "img/instruction2.608ab706.png";